export interface ShapeConfig {
  width: number;
  height: number;
  render: (w: number, h: number) => JSX.Element;
  handleOffsets?: {
    top?: number;
    right?: number;
    bottom?: number;
    left?: number;
  };
  resizeAdjust?: number;
}

export const shapeMap: Record<string, ShapeConfig> = {
  square: {
    width: 100,
    height: 100,
    render: (w: number, h: number) => {
      const padding = 1.5;
      return (
        <rect
          x={padding}
          y={padding}
          width={w - 2 * padding}
          height={h - 2 * padding}
          rx={4}
        />
      );
    },
  },
  rectangle: {
    width: 200,
    height: 100,
    render: (w: number, h: number) => {
      const padding = 1.5;
      return (
        <rect
          x={padding}
          y={padding}
          width={w - 2 * padding}
          height={h - 2 * padding}
          rx={4}
        />
      );
    },
  },
  diamond: {
    width: 100,
    height: 100,
    render: (w: number, h: number) => {
      const leftX = 0;
      const rightX = w;
      const topY = 0;
      const bottomY = h;
      const centerX = w / 2;
      const centerY = h / 2;

      return (
        <path
          d={`
            M${centerX} ${topY}
            L${leftX} ${centerY}
            L${centerX} ${bottomY}
            L${rightX} ${centerY}
            Z
          `}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      );
    },
  },
  subprocess: {
    width: 200,
    height: 100,
    render: (w: number, h: number) => {
      const padding = 1.5;
      const leftLineX = 0.15 * w;
      const rightLineX = 0.835 * w;

      return (
        <>
          {/* Full-height outer box */}
          <rect
            x={padding}
            y={padding}
            width={w - 2 * padding}
            height={h - 2 * padding}
            rx={4}
          />

          {/* Full-height vertical bars */}
          <line x1={leftLineX} x2={leftLineX} y1={padding} y2={h - padding} />
          <line x1={rightLineX} x2={rightLineX} y1={padding} y2={h - padding} />
        </>
      );
    },
  },
  document: {
    width: 200,
    height: 100,
    render: (w: number, h: number) => {
      const p1 = 1;
      const p2 = w - 1;

      return (
        <path
          d={`
            M${p1} ${p1}
            H${p2}
            V${0.91 * h}
            C${w / 2} ${0.54 * h}, ${w / 2} ${1.28 * h}, ${p1} ${0.84 * h}
            V${p1}
            Z
          `}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      );
    },
    handleOffsets: {
      bottom: 0.925,
    },
    resizeAdjust: 5,
  },
  database: {
    width: 100,
    height: 100,
    resizeAdjust: -15,
    render: (w: number, h: number) => {
      const pad = Math.min(w, h) * 0.05;
      const ellipsePad = Math.min(w, h) * 0.015; // tighter horizontal margin

      const topY = pad + 0.05 * h;
      const midY = pad + 0.15 * h;
      const botY = pad + 0.85 * h;

      return (
        <>
          {/* Cylinder body */}
          <path
            d={`
              M${ellipsePad} ${topY}
              C${ellipsePad} ${midY}, ${w - ellipsePad} ${midY}, ${
              w - ellipsePad
            } ${topY}
              V${botY}
              C${w - ellipsePad} ${botY + 0.1 * h}, ${ellipsePad} ${
              botY + 0.1 * h
            }, ${ellipsePad} ${botY}
              V${topY}
              Z
            `}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          {/* Top ellipse */}
          <path
            d={`
              M${ellipsePad} ${topY}
              C${ellipsePad} ${topY - 0.1 * h}, ${w - ellipsePad} ${
              topY - 0.1 * h
            }, ${w - ellipsePad} ${topY}
              C${w - ellipsePad} ${topY + 0.1 * h}, ${ellipsePad} ${
              topY + 0.1 * h
            }, ${ellipsePad} ${topY}
            `}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      );
    },
  },
};
